import {share} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {getMessageFromException} from '../utilities/Util';
import {NotificationService} from './NotificationService';
import {Allocation, AllocationClient, PagedListOfAllocationListItem} from './api.client';
import {Observable} from 'rxjs';

// 003-retire-ngrx (US3): the allocation slice went component-local. Both
// consumers are allocation-scoped pages that refetch per navigation, and the
// detail page already fetches by :id from the route. Methods return the API
// observable; the components hold the data. (The old reducer's
// ALLOCATIONSDATA_ISLOADING handler wrote a typo'd dead field —
// isAllocationLoading — which simply disappears with the slice, D9.)
@Injectable()
export class AllocationService {
    constructor(private _allocationApiService: AllocationClient,
                private _notificationService: NotificationService) {
    }


    getAllocationsPaged(
        searchValue: string,
        pledgeTypeId: string,
        showZeroBalances: boolean,
        sortName?: string,
        limit?: number,
        offset?: number,
        descending?: boolean): Observable<PagedListOfAllocationListItem> {
        const request = this._allocationApiService.retrieveAllocationsPaged(
            searchValue,
            pledgeTypeId,
            showZeroBalances,
            limit,
            offset,
            sortName,
            null,
            descending
        ).pipe(share());
        request.subscribe({
            next: () => {
            }, error: () => {
                this._notificationService.showError('Error Loading Allocations');
            }, complete: () => {

            }
        });
        return request;
    }

    addAllocation(allocation: Allocation): Observable<Allocation> {
        const request = this._allocationApiService.addAllocation(allocation).pipe(share());
        this._notificationService.showSuccess('Attempting to save new Allocation.');
        request.subscribe({
            next: () => {
                this._notificationService.showSuccess('Allocation Successfully Created!');
            }, error: (err) => {
                this._notificationService.showError(getMessageFromException(err));
            }, complete: () => {

            }
        });
        return request;
    }

    updateAllocation(allocation: Allocation): Observable<Allocation> {
        const request = this._allocationApiService.updateAllocation(allocation).pipe(share());
        this._notificationService.showSuccess('Attempting to update Allocation.');
        request.subscribe({
            next: () => {
                this._notificationService.showSuccess('Allocation Successfully Updated!');
            }, error: (err) => {
                this._notificationService.showError('There was a problem updating this Allocation. ' + err);
            }, complete: () => {

            }
        });
        return request;
    }

    deleteAllocation(id: string): Observable<boolean> {
        const request = this._allocationApiService.deleteAllocation(id).pipe(share());
        this._notificationService.showSuccess('Attempting to delete Allocation.');
        request.subscribe({
            next: () => {
                this._notificationService.showSuccess('Allocation Successfully Deleted!');
            }, error: (err) => {
                this._notificationService.showError(getMessageFromException(err));
            }, complete: () => {

            }
        });

        return request;
    }

    getAllocationById(id: string): Observable<Allocation> {
        return this._allocationApiService.retrieveAllocation(id).pipe(share());
    }
}
